import {
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  UseDisclosureProps,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useAlltickets } from "../../../hooks/useAllTickets.ts";
import { useCheckTickets } from "../../../hooks/useCheckTickets.ts";
import { BookingTickets } from "./bookingTickets.tsx";
import { CheckTickets } from "./checkTickets.tsx";

interface IProps {
  onClose: UseDisclosureProps["onClose"];
}

export const Tickets = ({ onClose }: IProps) => {
  const { tickets } = useAlltickets();
  const { loading, orderConfirmed, onSubmit, setOrderConfirmed } =
    useCheckTickets();
  const methods = useForm({ mode: "all" });

  useEffect(() => {
    if (tickets) {
      methods.setValue("idEvent", tickets.idEvent);
      methods.setValue("idEventTicket", tickets.id);
      const arr = tickets.eventTicketInfoList.map((item) => ({
        ticketInfo: item.ticketInfo.map((item) => {
          return { idEventTicketInfo: item.id, quantity: 0 };
        }),
      }));
      methods.setValue("eventTicketInfo", arr);
    }
  }, [tickets]);

  return (
    <>
      <ModalOverlay />
      <ModalContent>
        <ModalCloseButton />
        {!orderConfirmed && (
          <FormProvider {...methods}>
            <form>
              {tickets && (
                <CheckTickets {...{ onClose, onSubmit, loading, tickets }} />
              )}
            </form>
          </FormProvider>
        )}
        {!!orderConfirmed && (
          <BookingTickets {...{ orderConfirmed, setOrderConfirmed, onClose }} />
        )}
      </ModalContent>
    </>
  );
};
